module.exports = __webpack_public_path__ + "assets/img/header-small.d625e45d.webp";